import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import axios from "axios";
import { reportInventoryPercentagesTypes } from "redux/reducers/Reports/reportInventoryPercentages/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";

const { SET_INVENTORY_PERCENTAGES_FILTERS } = reportInventoryPercentagesTypes;

export const getReportInventoryPercentagesAction = ({ month, year, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    dispatch(startRequestComp('loadingInventoryPercentages'));
    try {
      const token = getState().login.token || localStorage.getItem('crm-user');
      const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/reports/inventory-percentages`;
      const fileName = `Reporte_Porcentajes_Inventario_${station.name}_${year}_${month}.${isPdf ? "pdf" : "xlsx"}`;

      const file = await axios({
        url: reportUrl,
        method: 'GET',
        responseType: 'blob',
        headers: { authorization: token },
        params: { month, year, idStation: station.id, pdf: isPdf },
      });

      saveAs(file.data, fileName);
      dispatch(setSnackbar("Reporte descargado con éxito", "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err), "danger"));
    } finally {
      dispatch(stopRequestComp('loadingInventoryPercentages'));
    }
  };
};

export const setReportInventoryPercentagesFilters = (key = "", value) => ({
  type: SET_INVENTORY_PERCENTAGES_FILTERS,
  payload: { key, value }
});
